import React from 'react';
import MaskedInput from 'react-maskedinput';
import {FormattedMessage} from 'react-intl';
import VirtualizedSelect from 'react-virtualized-select';
import { isRingoKg } from '../../../shared/domainUtils';

function CountryOptionRenderer ({focusedOption, focusOption, option, selectValue, valueArray, style}) {
    const classNames = ["countryOption"];
    if (option === focusedOption) {
        classNames.push("countryOptionFocused");
    }
    if (valueArray.indexOf(option)) {
        classNames.push("countryOptionSelected");
        classNames.push(option.iconClass);
    }
    const optionStyle = {
        ...style,
        backgroundRepeat: 'no-repeat',
        width: '300px'
    };

    return (
        <div className={classNames.join(' ')}
             style={ optionStyle }
            onClick={() => selectValue(option)}
            onMouseOver={() => focusOption(option)}>
            <label className="countryLabel">
                {option.name}
            </label>
        </div>
    );
}

const selectedCountryTemplate = (country) => {
    return (
        <div key={country.id} className={country.iconClass}/>
    );
};

export default class FormCountryPhoneField extends React.Component {
    static propTypes = {
        phone: React.PropTypes.object.isRequired,
        countryId: React.PropTypes.object.isRequired,
        message: React.PropTypes.object.isRequired,
        countryCode: React.PropTypes.object.isRequired,
        numberLength: React.PropTypes.object.isRequired,
        countries: React.PropTypes.object.isRequired,
        countryOptions: React.PropTypes.array.isRequired,
        required: React.PropTypes.bool
    };

    static renderHint(hint) {
        return (
            <div className="hint hint--error">
                <FormattedMessage {...hint}/>
            </div>
        );
    }

    constructor(props) {
        super(props);

        this._handleOnChange = this._handleOnChange.bind(this);

        const countryId = props.countryId.value;
        const country = props.countries[countryId];

        this.state = {
            menuIsOpen: true,
            value: {
                id: countryId,
                iconClass: country.short,
                name: country.name
            }
        };
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.countryCode.value !== nextProps.countryCode.value) {
            let tel = this.refs.tel.mask.value.join('');

            const newLength = nextProps.numberLength.value;
            const oldLength = this.props.numberLength.value;

            if (newLength > oldLength) {
                const diff = newLength - oldLength;
                for (let i = 0; i < diff; i++) {
                    tel = tel.concat('_');
                }
            } else {
                tel = tel.substring(0, newLength);
            }

            nextProps.phone.onChange(tel);
        }
    }

    _handleOnChange(e) {
        if (!e.id) {
            return;
        }

        const countryId = e.id;
        const country = this.props.countries[countryId];
        const countryCode = country.mask;
        const countryNumberLength = country.length;

        this.props.countryId.onChange(countryId);
        this.props.countryCode.onChange(countryCode);
        this.props.numberLength.onChange(countryNumberLength);

        this.setState({
            menuIsOpen: true,
            value: {
                id: countryId,
                name: country.name,
                iconClass: country.short
            }
        });
    }

    render() {
        const {
            required,
            phone,
            countryOptions,
            message,
            countryCode,
            numberLength,
            joinError,
            msg
            } = this.props;

        const notRequiredLabelClass = 'login--form__label form__label';
        const requiredLabelClass = 'login--form__label form__label form__label__required';

        const phoneInputClass = 'login--form__control form__phone-control';
        const countryInputClass = 'login--form__control form__country-control';
        const codeLabelClass = 'login--form__label form__code-label';

        const labelClass = required ? requiredLabelClass : notRequiredLabelClass;

        const countryCodeStr = `(${countryCode.value})`;
        const countrySelectDisabled = isRingoKg || true

        const mask = `${'111111111111'.slice(-numberLength.value)}`;

        return (
            <div className="form__row">
                <label className={labelClass}>
                    <FormattedMessage {...message}/>
                </label>

                <div style={{display: 'flex'}}>

                    <VirtualizedSelect name="country"
                                       className={countryInputClass}
                                       autofocus
                                       disabled={countrySelectDisabled}
                                       clearable={false}
                                       labelKey="name"
                                       options={countryOptions}
                                       valueKey="id"
                                       optionHeight={32}
                                       onChange={this._handleOnChange}
                                       value={this.state.value}
                                       noResultsText=""
                                       optionRenderer={CountryOptionRenderer}
                                       valueRenderer={selectedCountryTemplate}/>

                    <span className={codeLabelClass}>{countryCodeStr}</span>

                    <MaskedInput mask={mask}
                                 size={numberLength.value}
                                 className={phoneInputClass}
                                 ref="tel"
                        {...phone}/>

                    {phone.touched && phone.error && FormCountryPhoneField.renderHint(phone.error)}
                    {joinError && joinError === -2 && !phone.error && FormCountryPhoneField.renderHint(msg)}
                    {joinError && joinError === -4 && !phone.error && FormCountryPhoneField.renderHint({
                        id: 'join.errors.phone_not_found',
                        defaultMessage: 'Некорректный номер телефона'
                    })}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/registration/FormCountryPhoneField.jsx